import { LitElement, html } from 'lit-element';
import { render } from 'react-dom';
import * as React from 'react';
import * as style from './recirc-native-ad.style';
import RecircNativeAdReact, { Props } from './recirc-native-ad.react';
import { displayAdsLog } from '../../../utils/debug';

class RecircNativeAdComponent extends LitElement {
    name: string;

    private props: Props;

    // Creates a reactive property that triggers rendering
    static properties = {
        props: { type: Object },
    };

    createCollapsed(props: Props) {
        displayAdsLog(`recirc webcomp props: ${JSON.stringify(props)}`);
        return React.createElement(
            RecircNativeAdReact,
            props,
            React.createElement('slot', { className: 'slot' }),
        );
    }

    firstUpdated(props) {
        super.firstUpdated(props);
        const root = this.shadowRoot.getElementById(
            'recirc-web-component-root',
        );
        displayAdsLog(`recirc webcomp root: ${JSON.stringify(root)}`);
        if (root) {
            render(this.createCollapsed(this.props), root);
        }
    }

    // Render the component's DOM by returning a Lit template
    render() {
        return html`
            ${style.defaultStyle}
            <link
                rel="stylesheet"
                type="text/css"
                href="https://assets.finn.no/pkg/troika-css-core/v1/core.css"
            />
            <link
                rel="stylesheet"
                type="text/css"
                href="https://assets.finn.no/pkg/troika-css-utilities/1.0.6/utilities.css"
            />
            <link
                rel="stylesheet"
                type="text/css"
                href="https://assets.finn.no/pkg/troika-css-components/1.0.29/components.css"
            />
            <link
                rel="stylesheet"
                type="text/css"
                href="https://assets.finn.no/pkg/@fabric-ds/css/v1/fabric.min.css"
            />
            <div id="recirc-web-component-root"></div>
        `;
    }
}

export function defineRecircNativeAd() {
    if (!customElements.get('recirc-native-ad')) {
        customElements.define('recirc-native-ad', RecircNativeAdComponent);
    }
}
